import { useContext, useEffect } from 'react';
import useNRLazyQuery from '../../graphql/useNRLazyQuery';
import { GET_LICENSES_SPDX_IDS } from '../../graphql/queries/licenseIssues';
import { GenericContext } from '../GenericContext/GenericContextWrapper';
import { useFlag } from '@openfeature/react-sdk';
import { FEATURE_FLAGS } from '../../constants/constants';
import { SPDX_LICENSES } from '../../data/licenses';

const useFetchLicensesSpdxIds = () => {
  const { setLicensesSpdxIds, setLicensesSpdxIdsLoading } = useContext(GenericContext);
  const { value: isLicenseIssueEnable } = useFlag(FEATURE_FLAGS.LICENSE_ISSUES_FLAG, false);

  const [, isLoading, called, makeRequest] = useNRLazyQuery({
    query: GET_LICENSES_SPDX_IDS,
    options: {
      context: { version: 'v3' },
      fetchPolicy: 'cache-first'
    },
    qlObjKey: 'licensesSpdxIds',
    transformData: data => {
      setLicensesSpdxIds(data);
    }
  });

  useEffect(() => {
    setLicensesSpdxIdsLoading(isLoading);
  }, [isLoading, setLicensesSpdxIdsLoading]);

  // remove this fallback along with the feature flag when BE is ready. These loads local licenses when the feature flag is disabled.
  useEffect(() => {
    if (!isLicenseIssueEnable) {
      const localLicenseIds = SPDX_LICENSES?.map(lic => lic.licenseId).filter(Boolean) || [];
      setLicensesSpdxIds(localLicenseIds);
    }
  }, [isLicenseIssueEnable, setLicensesSpdxIds]);

  // Only fire the query once when the feature flag is enabled
  useEffect(() => {
    if (!isLicenseIssueEnable || called) return;

    makeRequest({
      context: { version: 'v3' }
    });
  }, [isLicenseIssueEnable, called]);
};

export default useFetchLicensesSpdxIds;
